export const _setContractAgency = (state, action) => {
  state.contractAgency = action.payload;
};

export const _setReviewDate = (state, action) => {
  state.reviewDate = action.payload;
};

export const _setClearDate = (state, action) => {
  state.clearDate = action.payload;
};
